export default {
  'BACKSPACE': 8,
  'SPACE': 32,
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  'DELETE': 46,
  'A': 65,
  'Z': 90
}
